import { Link, useNavigate } from 'react-router-dom';
import LanguageSwitcher from '../LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/images/logos/logo.png';

function Header() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleDownloadApp = () => {
    navigate('/app-download');
  };

  return (
    <header id="js-header" className="u-header u-header--static u-shadow-v19 p-3">
      <div className="flex flex-col md:flex-row items-center gap-4 md:gap-0 md:justify-between">
          {/* Logo on left */}
          <div className="w-full md:w-1/4 text-center md:text-left">
            <h1 className="text-2xl font-semibold flex justify-center">
              <Link to="/">
                <img src={logo} alt="logo" className="w-40" />  
              </Link>
              {/* <Link to="/">{t('bookstore')}</Link> */}
            </h1>
          </div>
          
          {/* Navigation in center */}
          <nav className="w-full md:w-2/4 items-center--md justify-center hidden md:flex">
            <button 
              className="px-4 py-2 bg-[#3bb18f] text-white rounded-lg hover:bg-[#2d8f73] transition-colors duration-300" 
              onClick={handleDownloadApp}
            >
              {t('getOurApp')}
            </button>
          </nav>

          {/* Language switcher on right */}
          <div className="w-full md:w-1/4 flex justify-center md:justify-end">
            <LanguageSwitcher />
          </div>
      </div>
    </header>
  );
}

export default Header;